// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"5":"7cd796ec","422":"18fa716f","452":"72fd5ab3","514":"7cbf7423","521":"5963383c","825":"2515a4f3","897":"ea602143"}[chunkId] + ".css";
};